import React from "react";
import AdminSidebar from "../../../components/AdminSidebar";
import BlueStockList from "../Devices/BlueStockList";
const BlueStockReport = () => {
  return (
    <AdminSidebar>
      <BlueStockList />
    </AdminSidebar>
  );
};

export default BlueStockReport;
